import { Box, TextField, Button, CircularProgress, Typography } from '@mui/material';
import BasicModal from '../common/BasicModal';
import Upload from '../common/Upload';
import InstagramPost from '../common/InstagramPost';
import { Dispatch, FC, SetStateAction, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MediaFile } from '../../interfaces/file';
import { CampaignContext } from '../../contexts/CampaignContext';
import { Info } from '@mui/icons-material';

type IRawContentModal = {
	open: boolean;
	rawModalPageId: string;
	rawModalInstructions: string;
	rawModalCaption: string;
	medias: MediaFile[];
	files: (File | string)[];
	sampleImage: (File | string)[];
	loading?: boolean;
	data?: { image: any; caption: string; type: string; dataType: string }[];
	setData?: Dispatch<SetStateAction<{ image: any; caption: string; type: string; dataType: string }[]>>;
	setSampleImage: React.Dispatch<React.SetStateAction<(File | string)[]>>;
	setFiles: React.Dispatch<React.SetStateAction<(File | string)[]>>;
	onClose: () => void;
	onPostDescriptionChange: (e: any) => void;
	onPageIdChange: (e: any) => void;
	onRawModalInstructionsChange: (e: any) => void;
	onSave: () => void;
};

const RawContentModal: FC<IRawContentModal> = ({ loading, medias, files, data, setData, rawModalPageId, rawModalCaption, rawModalInstructions, sampleImage, setSampleImage, onPageIdChange, setFiles, onClose, onPostDescriptionChange, onRawModalInstructionsChange, onSave, open }) => {
	const [pageIdError, setPageIdError] = useState<string>('');
	const { t } = useTranslation();
	const { selectedContentType, IsSerialStory, selectedPlatform } = useContext(CampaignContext);
	const isPost = selectedContentType === 'post';

	const handlePageIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		onPageIdChange(e);
		if (value.length < 100) {
			setPageIdError('');
		} else {
			setPageIdError('page_id_cannot_exceed_100_characters');
		}
	};

	const isEnabled = (medias.length > 0 || (data && data?.length > 0)) && rawModalCaption && (selectedPlatform === 'influenceral' || selectedPlatform === 'instagram' ? rawModalPageId.length < 100 && rawModalPageId.length > 0 : true);
	return (
		<BasicModal
			className={`${loading ? 'min-h-60' : 'h-auto'} ${isPost ? 'w-[913px]' : selectedPlatform === 'influenceral' ? 'w-full' : 'w-auto'}`}
			open={open}
			onClose={onClose}
			titleKey={`${IsSerialStory ? 'serial_story' : 'raw_content_modal_title'}`}
			titleValues={{
				contentType: t(selectedContentType as string),
			}}
		>
			<div className={`flex w-full gap-x-4 pt-8 ${loading ? 'justify-center' : 'justify-between'}`}>
				{loading ? (
					<CircularProgress size={30} className="mt-5" />
				) : (
					<>
						<Box className={`flex grow basis-0 flex-col ${isPost ? '' : 'justify-start'} gap-y-3`}>
							<TextField fullWidth onChange={onPostDescriptionChange} label={t('caption')} multiline rows={4} value={rawModalCaption} />
							{selectedPlatform === 'instagram' || selectedPlatform === 'influenceral' ? <TextField fullWidth onChange={handlePageIdChange} label={t('link_page_in_add_story')} value={rawModalPageId} /> : ''}
							<Typography className="text-red-500">{t(pageIdError)}</Typography>
							{!isPost && selectedPlatform === 'instagram' && (
								<Box className={`flex rounded-md border border-dashed border-primary-main bg-info-hover px-6 py-4`}>
									<Info className="me-2 h-6 w-6 text-primary-main" />
									<Typography>{t('guide_upload_image')}</Typography>{' '}
								</Box>
							)}
							<div className="item-center flex gap-4">
								<Upload type={'media'} className={`${!isPost ? 'w-1/2' : 'w-full'}`} IsSerialStory={IsSerialStory} isPost={isPost} files={isPost ? files : sampleImage} setFiles={isPost ? setFiles : setSampleImage} text={t('upload_sample_image')} multiple />
								{!isPost && <Upload type={'media'} data={data} caption={rawModalCaption} setData={setData} className="w-1/2" IsSerialStory={IsSerialStory} isPost={isPost} files={isPost ? sampleImage : files} setFiles={isPost ? setSampleImage : setFiles} text={t('upload_custom_image')} multiple />}
							</div>
							<TextField fullWidth onChange={onRawModalInstructionsChange} label={t('instructions')} multiline rows={2} value={rawModalInstructions} />
							<Button size="large" onClick={onSave} disabled={!isEnabled}>
								{t('register')}
							</Button>
						</Box>
						<Box className="w-[350px]">
							<InstagramPost medias={medias} data={data} setData={setData} staticContent={true} caption={rawModalCaption} />
						</Box>
					</>
				)}
			</div>
		</BasicModal>
	);
};

export default RawContentModal;
